import { crypto } from "../crypto.js";
import { nextMark } from "@local/extensions/identifiers/mark.js";

interface Note {
  id: string;
  group_id: string;
  mark: string;
  title?: string;
  body?: string;
  created_at?: Date,
  updated_at?: Date;
  approval_status: string;
  sort_order: number;
}

function createNote(group_id: string, notes = Array<Note>) {
  const mark = nextMark(notes);
  const maxIndex = notes.reduce((max, note) => note.sort_order > max ? note.sort_order : max, 0);

  return {
    id: crypto.randomUUID(),
    group_id,
    mark,
    title: "Note",
    body: null,
    created_at: new Date(),
    updated_at: new Date(),
    approval_status: "none",
    sort_order: maxIndex + 1,
  }
}

export {
  createNote
}